/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import sidekick from '@last-rev/contentful-sidekick-util';
import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import snakeCase from 'lodash/snakeCase';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useCourseTopicContext } from '../../CourseTopicContext';
import { coveoUaRightClick } from '../../apis/coveouaclick';
import styles from './ElementLink.module.scss';

export const ElementLinkPropTypes = {
  _id: PropTypes.string,
  _contentTypeId: PropTypes.string,
  className: PropTypes.string,
  href: PropTypes.string.isRequired,
  as: PropTypes.string,
  linkText: PropTypes.string,
  icon: PropTypes.string,
  target: PropTypes.string,
  isModal: PropTypes.bool,
  download: PropTypes.bool,
  trackingId: PropTypes.string,
  style: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  searchUid: PropTypes.string,
  permanentid: PropTypes.string
};

const NextLinkPropTypes = {
  _id: PropTypes.string,
  _contentTypeId: PropTypes.string,
  href: PropTypes.string.isRequired,
  as: PropTypes.string,
  className: PropTypes.string,
  trackingId: PropTypes.string,
  children: PropTypes.node.isRequired,
  displayText: PropTypes.string,
  searchUid: PropTypes.string,
  permanentid: PropTypes.string
};

const StandardLinkPropTypes = {
  _id: PropTypes.string,
  _contentTypeId: PropTypes.string,
  href: PropTypes.string.isRequired,
  target: PropTypes.string,
  className: PropTypes.string,
  isModal: PropTypes.bool.isRequired,
  download: PropTypes.bool.isRequired,
  trackingId: PropTypes.string,
  children: PropTypes.node.isRequired,
  displayText: PropTypes.string,
  onClick: PropTypes.func,
  searchUid: PropTypes.string,
  permanentid: PropTypes.string
};
const handleClick = (href, displayText, searchUid, permanentid, vistorid) => {
  coveoUaRightClick(href, displayText, searchUid, permanentid, vistorid);

};
let isSearchRelated = false;
const StandardLink = ({
  _id = null,
  _contentTypeId = null,
  target = null,
  href,
  className = null,
  isModal,
  download,
  trackingId = null,
  children,
  displayText = null,
  onClick = null,
  searchUid,
  permanentid,
  vistorid,
  slashIcon,
  slashIconClassName,
  parent_contentTypeId
}) => {
  if (isModal) {
    /* onClick = () => {
       // TODO: handle opening modal
     }; */
  }
  const handleClickEvent = (event) => {
    onClick(event)
    //handleClick(searchUid);

  }
  let visitorId = '';
  useEffect(() => {
    // Code to run on initial component mount only
    visitorId = localStorage.getItem('visitorId');
  }, [])

  if (trackingId != null && trackingId.includes('page_search')) {
    isSearchRelated = true;
  }
  return (
    <>
      {isSearchRelated ? (
        <a
          data-uxa-log={trackingId}
          data-uxa-interactions="click shown"
          data-searchid={searchUid}
          data-permanentid={permanentid}
          data-vistorid={vistorid}
          onContextMenu={() => handleClick(href, displayText, searchUid, permanentid, vistorid)}
          className={`
           ${className}
           ${slashIcon ? slashIconClassName : ""}
           ${parent_contentTypeId === "pageCourseTopic" ? styles.LinkWrapper : ""}
          `} 
          href={href}
          target={target}
          aria-label={target && target !== '_self' && `Open ${displayText} in a new tab`}
          rel="noopener noreferrer"
          data-testid="ElementLink"
          download={download}
          {...sidekick(_id, null, _contentTypeId, displayText)}>
          {children}
        </a>
      ) : (
        <a
          data-uxa-log={trackingId}
          data-uxa-interactions="click shown"
          onClick={onClick}
          className={`
            ${className}
            ${slashIcon ? slashIconClassName : ""}
            ${parent_contentTypeId === "pageCourseTopic" ? styles.LinkWrapper : ""}
         `}
          href={href}
          target={target}
          aria-label={target && target !== '_self' && `Open ${displayText} in a new tab`}
          rel="noopener noreferrer"
          data-testid="ElementLink"
          download={download}
          {...sidekick(_id, null, _contentTypeId, displayText)}>
          {children}
        </a>
      )}
    </>
  );
};

StandardLink.propTypes = StandardLinkPropTypes;

const NextLink = ({ _id = null, _contentTypeId = null, href, as = null, className = null, trackingId = null, children, displayText = null, slashIcon, slashIconClassName }) => {
  const { lang } = useTranslation();

  return (
    <Link locale={lang === 'pt-BR' ? 'pt-br' : lang} href={href} as={as}>
      <a
        className={className}
        data-testid="ElementLink"
        data-uxa-log={trackingId}
        data-uxa-interactions="click shown"
        {...sidekick(_id, null, _contentTypeId, displayText)}>
        {children}
      </a>
    </Link>
  );
};

NextLink.propTypes = NextLinkPropTypes;


const getFullClassName = ({ style, className, icon }) => {
  if (!style && !className && !icon) return null;
  return `${style ? `link_${style}` : ''} ${className || ''} ${icon ? `icon_${snakeCase(icon)}` : ''}`;
};

const getLastPathSegment = (path) => {
  if (!path) return path;

  const regex = /\/([^/]+)$/; // Matches the last slash and everything after it

  const match = path.match(regex);
  if (match) {
    const result = match[1]; // The captured group contains what's after the last slash
    return result;
  }
  return path;
};

function ElementLink({
  _id = null,
  _contentTypeId = null,
  className = null,
  href: initialHref,
  as: initialAs,
  target = null,
  linkText,
  icon = null,
  isModal = false,
  download = false,
  trackingId = null,
  style = null,
  children = null,
  onClick = null,
  searchUid = null,
  permanentid = null,
  vistorid = null,
  slashIcon,
  slashIconClassName,
  parent,
  parent_contentTypeId
}) {
  const { getTopicPath } = useCourseTopicContext();
  let href = initialHref;
  let as = initialAs;

  const fullClassName = getFullClassName({ style, className, icon });


  // TODO: is this enough of a check? Someone could pass in
  // my.website.com/something, and this should be handled
  const isInternal = href && href.startsWith('/');
  const isTargetSelf = !target || target === '_self';

  // if the window should change URl without refreshing the page,
  // use Next/Link
  const useNextLink = isInternal && !download && !isModal && !onClick && isTargetSelf;

  if (useNextLink) {
    const slug = getLastPathSegment(as);
    const path = getTopicPath(slug);
    if (as && as === `/self-guided-learning/${slug}`) {

      if (path && path !== initialAs) {
        as = as.replace(`/${slug}`, path);
        href = href.replace(`[topicslug]`, '[slug]/[topicslug]');
      }
    }


    /*if (trackingId && trackingId.endsWith('/[slug]')) {
      trackingId = trackingId.replace('/[slug]', `${path}`);
    }
    if(trackingId && path && trackingId.endsWith('/[topicslug]')) {
      trackingId = trackingId.replace('/[topicslug]', `${path}`);
    }*/

    if (trackingId && path) {
      if (trackingId.endsWith('/[slug]')) {
        trackingId = trackingId.replace('/[slug]', `${path}`);
      }
      if (trackingId.endsWith('/[topicslug]')) {
        trackingId = trackingId.replace('/[topicslug]', `${path}`);
      }
    }

    return (
      <NextLink
        _id={_id}
        _contentTypeId={_contentTypeId}
        href={as === '/home' ? '/' : href}
        as={as === '/home' ? '/' : as}
        className={fullClassName}
        trackingId={trackingId}
        target={target}
        isModal={isModal}
        download={download}
        slashIcon={slashIcon}
        slashIconClassName={slashIconClassName}
        displayText={linkText}>
        {parent ? linkText : (children || linkText)}
      </NextLink>
    );
  }

  return (
    <StandardLink
      _id={_id}
      _contentTypeId={_contentTypeId}
      target={target}
      href={href}
      onClick={onClick}
      className={fullClassName}
      aria-label={target && !isTargetSelf && `Open ${linkText} in a new tab`}
      isModal={isModal}
      download={download}
      trackingId={trackingId}
      slashIcon={slashIcon}
      displayText={linkText}
      permanentid={permanentid}
      searchUid={searchUid}
      slashIconClassName={slashIconClassName}
      vistorid={vistorid}
      parent_contentTypeId={parent_contentTypeId}>
      {parent ? linkText : (children || linkText)}
    </StandardLink>
  );
}

ElementLink.propTypes = ElementLinkPropTypes;

export default ElementLink;